import React from 'react';
import PopOverMenu from '../../../PopOverMenu';
import {
    isClubAdminOrOwner,
} from '../../../../utils/clubs';
import AddPhoto from '../../../PhotoUpload/AddPhoto';
import Img from '../../../Img';
import styles from '../../../../pages/ClubProfiles/club.scss';

class ClubSponsorLogo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
        this.setSponsorLogoRef = this.setSponsorLogoRef.bind(this);
        this.handlePhotoPopoverClick = this.handlePhotoPopoverClick.bind(this);
        this.logoInputRef = React.createRef();
    }

    componentWillUnmount() {
        if (this.sponsorLogo) {
            this.sponsorLogo.removeEventListener('load', this.updateSponsorLogo);
        }
    }

    setSponsorLogoRef(img) {
        this.sponsorLogo = img;
        if (this.sponsorLogo) {
            this.sponsorLogo.addEventListener('load', this.updateSponsorLogo);
        }
    }

    updateSponsorLogo() {
        if (this.sponsorLogo) {
            const src = this.sponsorLogo.currentSrc ? this.sponsorLogo.currentSrc : this.sponsorLogo.src;
            this.sponsorLogo.parentNode.style.backgroundImage = `url("${src}")`;
        }
    }

    handlePhotoPopoverClick(item) {
        const { id } = this.props.clubDetails;
        switch (item.value) {
            case 'remove_sponsor_logo':
                this.props.removeSponsorLogo(id);
                break;
            case 'upload_sponsor_logo':
                this.logoInputRef.current.click();
                break;
            default:
                break;
        }
    }

    render() {
        const { clubDetails } = this.props;

        const {
            sponsorLogoUrl,
        } = clubDetails;

        const sponsorLogoBg = sponsorLogoUrl ? `/v1/club/${sponsorLogoUrl}` : null;

        return (
            <React.Fragment>
                <div>
                    {clubDetails && clubDetails.isPro && sponsorLogoUrl && (
                        <div className={`${styles.clubSponsorLogoContainer} text-center`}>
                            <div className={`title-uppercase ${styles.sponsoredBy}`}>Sponsored by</div>
                            <div className={`${styles.clubSponsorLogo}`}>
                                <Img
                                    className={'mt16 mb16 '}
                                    src={sponsorLogoBg}
                                    onImgLoad={this.setSponsorLogoRef}
                                    onError={(e) => {
                                        e.target.src = '';
                                        e.target.srcset = '';
                                    }}
                                />
                                {(isClubAdminOrOwner(clubDetails)) && (
                                    <div className={`${styles.editSponsorLogo} mt16`}>
                                        <PopOverMenu
                                            menuItems={[
                                                ...([{ value: 'upload_sponsor_logo', label: 'Upload' }]),
                                                ...sponsorLogoUrl ? ([{ value: 'remove_sponsor_logo', label: 'Remove' }]) : [],
                                            ]}
                                            onSelected={this.handlePhotoPopoverClick}
                                        >
                                            <button
                                                type="button"
                                                className={`btn ${styles.editSponsorLogoBtn}`}
                                            >
                                                <i className="far fa-image" />
                                            </button>
                                        </PopOverMenu>
                                        <AddPhoto
                                            maxSize={180}
                                            uploadPhoto={this.props.handleUploadPhoto}
                                            uploadStart={this.props.handleUploadLogoStart}
                                            text={'Upload'}
                                            // TODO: Refactor AddPhoto component
                                            // eslint-disable-next-line
                                        style={2}
                                            inputRef={this.logoInputRef}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </React.Fragment>
        );
    }
}

export default ClubSponsorLogo;
